import { useMemo } from "react";
import type { StepKey } from "@/react/types/Checklist";
import { stepKeys } from "@/react/types/Checklist";
import { ConfirmAccessContent } from "./customContent/ConfirmAccessContent";

export const useChecklistCustomContent = () => {
  const stepCustomContent: Partial<Record<StepKey, React.ComponentType>> =
    useMemo(
      () => ({
        [stepKeys.confirm_access]: ConfirmAccessContent,
      }),
      [],
    );

  const getStepCustomContent = (
    stepKey: StepKey,
  ): React.ComponentType | undefined => stepCustomContent[stepKey];

  return {
    getStepCustomContent,
    stepCustomContent,
  };
};
